import React, { useState } from 'react'
import TreeTableMovements from '../../../../components/table/TreeTableMovements';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import ListMaterial from './ListMaterial';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
const dataa = {
    "status": "Success",
    "message": "تم جلب البيانات بنجاح",
    "data": [
        {
            "id": 1,
            "name": "zone 1",
            "symbol": "Z1",
            "description": "the first large area",
            "materials": null,
            "sub_zones": [
                {
                    "id": 3,
                    "name": "Aisle 1",
                    "symbol": "A1",
                    "description": "the first large area",
                    "materials": null,
                    "sub_zones": [
                        {
                            "id": 4,
                            "name": "Aisle 2",
                            "symbol": "A2",
                            "description": "the first large area",
                            "materials": {
                                "id": 15,
                                "material_id": 1,
                                "warehouse_zone_id": 4,
                                "zone": "Z1-A1-A2",
                                "quantity": 7,
                                "status": true,
                                "created_at": null
                            }
                        }
                    ]
                }
            ]
        },
        {
            "id": 2,
            "name": "zone 2",
            "symbol": "Z2",
            "description": "the first large area",
            "materials": null
        }
    ],
    "statusCode": 200
}


function Movements() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const [data, setData] = useState(dataa)
    const [open,setOpen] = useState(false)
    const [zone_id,setzone_id] = useState(null)
    const columns = [translate('select'), translate('name'), translate('symbol'),translate('zone'),translate('qty'), translate('actions')];
    return (
        <>
            <TreeTableMovements langLocal={langLocal} translate={translate} columns={columns} data={data.data} open={open} setOpen={setOpen} setzone_id={setzone_id}/>
            {
                open &&(
                    <ListMaterial open={open} setOpen={setOpen} />
                )
            }
        </>
    )
}

export default Movements